import * as d3 from 'd3'
import { isFloat } from './mapsUtils'
const addText=(global:any,x:number,y:number,text:string,textcolor:string,fontsize:number,isBold:boolean)=>{
	const textTitle =global.append("text")
		.attr('y',y)
		.attr('x',x)
		.attr('fill',textcolor)
		.attr("font-size",fontsize)
		.attr("font-weight", isBold?700:350)
		.attr("font-family", "Sans-Serif")
		textTitle.html(text)
}

const drawTriangle=(container:any,x:number,y:number)=>{
    container.append('path')
    .attr("d", d3.symbol().type(d3.symbolTriangle2).size(100))
	.attr('x',x) 
	.attr('y',y)
	.attr("transform", "translate("+x+", "+y+") rotate(180)")
    .style("fill", '#4D4F52')
	.attr('opacity',.9)
}
function drawPopup(context:any,x:number,y:number,popupKey:string,text1:string, text2:string,text3:string,text4:string,isMobileVersion:boolean,fCorrection?: number){
	let caracters = Math.max(text1.length,text2.length+text3.length+4,text4.length*0.7)
	const popupGroup = context
			.append('g')
			.attr('id', 'popup-g-'+popupKey)
			.attr("class", "popup-g")
	drawTriangle(popupGroup,0,0)
	  popupGroup.append("rect")
   .attr("class","popup d"+popupKey)
   .attr('x',-(caracters*4.5)) 
   .attr('y',-70)
   .attr('height', '70px')
   .attr('width', caracters*9+'px')
   .attr('fill','#4D4F52')
   .attr('rx','5px')
   .attr('opacity',1)   
    addText(popupGroup,(-caracters*4.5)+5,-50,text1,'#FFFFFF',16,false)
   addText(popupGroup,(-caracters*4.5)+5,-25,text2,'#FFFFFF',25,true)
   addText(popupGroup,isFloat(text2)?((-caracters*4.5)+60):(-caracters*4.5)+35,-25,text3,'#FFFFFF',16,false) 
   addText(popupGroup,(-caracters*4.5)+5,-7,text4,'#FFFFFF',12,false) 
   const popupToLeftPoint=getPopupTopLeftPoint(popupKey,isMobileVersion, fCorrection)
   popupGroup.attr("transform", `translate(${popupToLeftPoint.x},${popupToLeftPoint.y})`)
}

function getPopupTopLeftPoint(popupKey:string,isMobileVersion:boolean,fCorrection?: number): DOMPoint {
	// retrieve map group and its transformation matrix relative to the parent svg coordinate system.
	const mapEl = d3.select('#map-elements').node() as SVGGeometryElement;
	const matrix = mapEl.getCTM(); // it's sufficient because we don't apply any transformation to the parent svg.
	if (typeof fCorrection === "number" && matrix) matrix.f -= fCorrection;
	// retrieve region path and its bounding box
	const regionEl: SVGGeometryElement = d3.select("#d" + popupKey).node() as SVGGeometryElement;
	const regionBbox = regionEl.getBBox();
	// calculate the popup anchor point pointed by the popup triangle in the parent svg coordinate system.
	// (the anchor point is at the center of the bounding box)
	const anchorPoint = new DOMPoint((regionBbox.x + regionBbox.width / 2), (regionBbox.y + regionBbox.height / 2)).matrixTransform(matrix ?? undefined);
	const topLeftPoint = new DOMPoint(anchorPoint.x, anchorPoint.y);
	return topLeftPoint;
}

export {drawPopup,getPopupTopLeftPoint}